import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Quizzes Icon
 *
 * @file Quizzes.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const Quizzes = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 19 14" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.27692 0.886719C3.10535 0.886719 3.77692
        1.55829 3.77692 2.38672C3.77692 3.21515 3.10535
        3.88672 2.27692 3.88672C1.4485 3.88672 0.776924
        3.21515 0.776924 2.38672C0.776924 1.55829 1.4485
        0.886719 2.27692 0.886719ZM3.77692 7.06851C3.77692
        6.24008 3.10534 5.56851 2.27692 5.56851C1.44849
        5.56851 0.776917 6.24008 0.776917 7.06851C0.776917
        7.89694 1.44849 8.56851 2.27692 8.56851C3.10534
        8.56851 3.77692 7.89694 3.77692 7.06851ZM3.77692
        11.7503C3.77692 10.9219 3.10534 10.2503 2.27692
        10.2503C1.44849 10.2503 0.776917 10.9219 0.776917
        11.7503C0.776917 12.5787 1.44849 13.2503 2.27692
        13.2503C3.10534 13.2503 3.77692 12.5787 3.77692
        11.7503ZM2.27692 12.5003C2.69113 12.5003 3.02692
        12.1645 3.02692 11.7503C3.02692 11.3361 2.69113
        11.0003 2.27692 11.0003C1.8627 11.0003 1.52692
        11.3361 1.52692 11.7503C1.52692 12.1645 1.8627
        12.5003 2.27692 12.5003ZM17.5518 10.7503C18.0396
        10.7503 18.4351 11.198 18.4351 11.7503C18.4351
        12.3026 18.0396 12.7503 17.5518 12.7503H6.06842C5.58057
        12.7503 5.18509 12.3026 5.18509 11.7503C5.18509 11.198
        5.58057 10.7503 6.06842 10.7503H17.5518ZM3.02692
        7.06851C3.02692 7.48273 2.69113 7.81851 2.27692
        7.81851C1.8627 7.81851 1.52692 7.48273 1.52692 7.06851C1.52692
        6.6543 1.8627 6.31851 2.27692 6.31851C2.69113 6.31851
        3.02692 6.6543 3.02692 7.06851ZM18.4351 7.06851C18.4351
        6.51623 18.0396 6.06851 17.5517 6.06851H6.06841C5.58056
        6.06851 5.18508 6.51623 5.18508 7.06851C5.18508 7.6208
        5.58056 8.06851 6.06841 8.06851H17.5517C18.0396 8.06851
        18.4351 7.6208 18.4351 7.06851ZM18.4351 2.38672C18.4351
        1.83443 18.0396 1.38672 17.5518 1.38672H6.06843C5.58057
        1.38672 5.18509 1.83443 5.18509 2.38672C5.18509 2.939
        5.58057 3.38672 6.06843 3.38672H17.5518C18.0396 3.38672
        18.4351 2.939 18.4351 2.38672Z"
      fill="currentcolor"
    />
  </SvgIcon>
);

export default Quizzes;
